<template>
    <veui-dialog
        class="operation-auth-dialog"
        overlay-class="operation-dialog-overlay"
        :open="open"
        :closable="false"
        @update:open="onOpenChange"
    >
        <template #title>
            <div class="title">代运营服务授权</div>
            <div
                class="close-btn"
                @click="onOpenChange(false)"
            ></div>
        </template>
        <div class="ts-body">
            <div class="ts-lead">
                代理商“<span class="ts-strong">{{ agentName }}</span>”邀请您授权“
                <span class="ts-strong">代运营</span>”托管服务
            </div>
            <div class="ts-desc">
                授权后代理商可优化您的资料、开启智能抢答并反馈运营数据、提升运营效率，所有操作均有记录，您可随时查看并「撤回授权」
            </div>
            <img
                class="ts-illus"
                src="https://lvlin-fe-saas.bj.bcebos.com/home/operation-authorize-illuss.png"
            />
        </div>
        <template #foot>
            <div class="ts-foot">
                <veui-button
                    class="ts-btn ts-btn-minor"
                    :loading="rejectLoading"
                    :disabled="loading"
                    @click="onReject"
                >拒绝托管</veui-button>
                <veui-button
                    class="ts-btn ts-btn-primary"
                    ui="primary"
                    :loading="loading"
                    :disabled="rejectLoading"
                    @click="onAgree"
                >授权托管</veui-button>
            </div>
        </template>
    </veui-dialog>
</template>

<script>
import {Dialog, Button} from 'veui';

export default {
    name: 'OperationAuthDialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        // 弹窗展示状态
        open: {
            type: Boolean,
            default: false
        },
        agentName: {
            type: String,
            default: ''
        },
        // 授权按钮加载态
        loading: {
            type: Boolean,
            default: false
        },
        // 拒绝按钮加载态
        rejectLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        };
    },
    methods: {
        onOpenChange(val) {
            if (!val) {
                this.$emit('dismiss');
            }
        },
        onReject() {
            this.$emit('reject');
        },
        onAgree() {
            this.$emit('agree');
        }
    }
};
</script>
<style scoped lang="less">
.operation-dialog-overlay {
    /deep/.veui-dialog-box-mask {
        background-color: rgba(0, 0, 0, .3);
    }

    /deep/.veui-dialog-content {
        width: 516px;
        padding-bottom: 0;
        position: relative;
        border-radius: 6px;
    }

    /deep/.veui-dialog-content-head {
        padding: 18px 24px 6px;
    }

    /deep/.veui-dialog-content-head-title {
        display: flex;
        flex: 1;
        align-items: center;
        color: #000311;
        font-size: 18px;
        line-height: 18px;
        font-weight: 500;
    }

    /deep/.veui-dialog-content-body {
        padding: 12px 24px 18px 24px;
    }

    /deep/.veui-dialog-content-foot {
        padding: 6px 24px 18px;
        margin-left: auto;
    }

    .close-btn {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 18px;
        right: 21px;
        background: url("https://lvlin-sp-saas.cdn.bcebos.com/assets/trusteeship/dialog-close-release.png") no-repeat;
        background-size: cover;
        cursor: pointer;
        z-index: 1;
        transform: translateY(-3px);
    }

    .ts-body {
        .ts-lead {
            font-size: 16px;
            line-height: 16px;
            color: #1e1f24;
        }

        .ts-strong {
            font-weight: 600;
        }

        .ts-desc {
            font-size: 14px;
            line-height: 22px;
            color: #848691;
            margin-top: 7px;
        }

        .ts-illus {
            display: block;
            width: 100%;
            height: auto;
            border-radius: 10px;
            margin-top: 13px;
        }
    }

    .ts-foot {
        display: flex;
        justify-content: flex-end;

        .ts-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 0;
            height: 44px;
            border-radius: 6px;
            font-size: 16px;
            line-height: 16px;
            font-weight: 500;
            box-sizing: border-box;
            cursor: pointer;

            &:focus,
            &:focus-visible {
                outline: none;
                box-shadow: none;
            }
        }

        .ts-btn-minor {
            width: 136px;
            color: #1e1f24;
            background: #fff;
            border: 1px solid rgba(30, 31, 36, .2);

            &:hover,
            &:focus,
            &:active {
                color: #1e1f24;
                background: #fff;
                border-color: rgba(30, 31, 36, .2);
            }
        }

        .ts-btn-primary {
            padding-inline: 36px;
            color: #fff;
            background: #0054ff;
            border-color: #0054ff;

            &:hover,
            &:focus,
            &:active {
                background: #004ce5;
                border-color: #004ce5;
            }
        }
    }
}
</style>
